import React, { useState } from 'react';
import { Button } from 'antd';
import styles from './RefundStep2.module.scss';
import styles3 from './BuyerReturnStep.module.scss';
import FAQSection from '../OrderServicePanel/FAQSection';
import StepBar from './StepBar';
import { CheckCircleFilled } from '@ant-design/icons';

interface BuyerReturnStepProps {
  formData: any;
  order?: any;
  onBack: () => void;
  onNext: () => void;
  serviceType: 'refundOnly' | 'refundAndReturn';
  stepData?: string[];
  currentStep?: number;
}

const BuyerReturnStep: React.FC<BuyerReturnStepProps> = ({ 
  formData, 
  order, 
  onBack, 
  onNext, 
  serviceType, 
  stepData, 
  currentStep 
}) => {
  // 有数据用数据，没数据用假数据/占位符
  const sellerName = formData?.sellerName || order?.sellerName || 'Apple Store';
  const userName = formData?.userName || order?.userName || 'Mike';
  const userAvatar = formData?.userAvatar || order?.userAvatar || 'https://randomuser.me/api/portraits/men/32.jpg';
  const refundReason = formData?.refundReason || order?.refundReason || 'Changed Mind';
  const refundAmount = formData?.refundAmount || order?.refundAmount || '5.99';
  const refundType = formData?.serviceType === 'refund' ? 'Refund' : (formData?.serviceType === 'return' ? 'Return and Refund' : (order?.serviceType === 'refund' ? 'Refund' : (order?.serviceType === 'return' ? 'Return and Refund' : 'Refund')));
  const product = formData?.product || (order?.products ? order.products[0] : {}) || {};
  const productImg = product?.img || order?.products?.[0]?.img || 'https://images.unsplash.com/photo-1519125323398-675f0ddb6308';
  const productTitle = product?.title || order?.products?.[0]?.title || 'Handmade Bamboo Basket: Woven with Bamboo...';
  const productClass = product?.classification || order?.products?.[0]?.classification || 'Shape Classification...';
  const orderNumber = formData?.orderNumber || order?.orderNumber || '14785236987463157245';
  const unitPrice = product?.price || order?.products?.[0]?.price || '5.99';
  const shippingFee = product?.shippingFee || order?.products?.[0]?.shippingFee || '0.00';
  const totalPrice = product?.totalPrice || order?.products?.[0]?.totalPrice || unitPrice;
  const refundNumber = formData?.refundNumber || orderNumber;
  const goodsStatus = formData?.goodsState === 'not_received' ? 'Not shipped' : (formData?.goodsState === 'received' ? 'Shipped' : (order?.goodsState === 'not_received' ? 'Not shipped' : (order?.goodsState === 'received' ? 'Shipped' : 'Not shipped')));
  const negotiationHistory = formData?.negotiationHistory || order?.negotiationHistory || [
    {
      userName,
      userAvatar,
      time: formData?.createdAt || order?.createdAt || '2025-07-01 10:20:20',
      action: 'Initiated A Refund Request',
      refundType,
      refundAmount,
      refundReason
    }
  ];

  const [returnType, setReturnType] = useState<'pickup' | 'self' | ''>('');
  const [pickupTime, setPickupTime] = useState<'08:00-13:00' | '13:00-22:00' | ''>('');
  const [trackingNumber, setTrackingNumber] = useState('');
  const [name, setName] = useState('');
  const [contactInfo, setContactInfo] = useState('');
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const [verificationCode, setVerificationCode] = useState('');
  function generateVerificationCode() {
    return Math.floor(1000 + Math.random() * 9000).toString();
  }

  // radio icon组件
  const RadioIcon = ({ checked }: { checked: boolean }) => (
    checked ? (
      <span style={{ color: '#21b47b', fontSize: 22, display: 'inline-flex', alignItems: 'center' }}>
        <CheckCircleFilled />
      </span>
    ) : (
      <span style={{
        display: 'inline-block',
        width: 22,
        height: 22,
        border: '2px solid #d9d9d9',
        borderRadius: '50%',
        background: '#fff',
        boxSizing: 'border-box',
      }} />
    )
  );

  return (
    <div className={styles['']}>
      <StepBar currentStep={currentStep || 3} stepData={stepData} />
      <div className={styles['refund-step2-layout']}>
        {/* 左侧主内容区 */}
        <div className={styles['main-panel']}>
          <div className={styles3['buyer-return-panel']}>
            <div className={styles3['buyer-return-title']}>Buyer Return</div>
            <div className={styles3['buyer-return-methods']} style={{ display: 'flex', gap: 24, marginBottom: 24 }}>
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                <div
                  className={styles3['buyer-return-card'] + (returnType === 'pickup' ? ' ' + styles3['selected'] : '')}
                  style={{ border:'1px solid #d9d9d9', borderRadius: 10, padding: 20, cursor: 'pointer', background: '#fff', position: 'relative', minHeight: 90 }}
                  onClick={() => setReturnType('pickup')}
                >
                  <div style={{ fontWeight: 600, fontSize: 17, color: '#222', marginBottom: 6 }}>In–home pickup</div>
                  <div className={styles3['buyer-return-card-desc']} title="Courier picks up the package at the door">Courier picks up the package at the door</div>
                  <span style={{ position: 'absolute', right: 18, top: 18 }}>
                    <RadioIcon checked={returnType === 'pickup'} />
                  </span>
                </div>
                {returnType === 'pickup' && (
                    <div style={{
                      border: '1px solid #d9d9d9',
                      borderRadius: 10,
                      background: '#fff',
                      padding: 0,
                      marginTop: 18,
                      marginBottom: 0
                    }}>
                      {/* 单选项列表 */}
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div
                          style={{ display: 'flex', alignItems: 'center', padding: '12px 24px', cursor: 'pointer' }}
                          onClick={() => setPickupTime('08:00-13:00')}
                        >
                          <div style={{ flex: 1 }}>
                            <div style={{ fontWeight: 500, fontSize: 16, color: '#222', marginBottom: 6 }}>After the merchant approves the return</div>
                            <div style={{ color: '#222', fontSize: 16 }}>08: 00–13: 00</div>
                          </div>
                          <RadioIcon checked={pickupTime === '08:00-13:00'} />
                        </div>
                        <div style={{ height: 1, background: '#ececec', margin: '0 24px' }} />
                        <div
                          style={{ display: 'flex', alignItems: 'center', padding: '12px 24px', cursor: 'pointer' }}
                          onClick={() => setPickupTime('13:00-22:00')}
                        >
                          <div style={{ flex: 1 }}>
                            <div style={{ fontWeight: 500, fontSize: 16, color: '#222', marginBottom: 6 }}>After the merchant approves the return</div>
                            <div style={{ color: '#222', fontSize: 16 }}>13: 00–22: 00</div>
                          </div>
                          <RadioIcon checked={pickupTime === '13:00-22:00'} />
                        </div>
                      </div>
                    </div>
                )}
              </div>
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                <div
                  className={styles3['buyer-return-card'] + (returnType === 'self' ? ' ' + styles3['selected'] : '')}
                  style={{ border: '1px solid #d9d9d9', borderRadius: 10, padding: 20, cursor: 'pointer',  position: 'relative', minHeight: 90 }}
                  onClick={() => setReturnType('self')}
                >
                  <div style={{ fontWeight: 600, fontSize: 17, color: '#222', marginBottom: 6 }}>Self–return</div>
                  <div className={styles3['buyer-return-card-desc']} title="Shipping fees must be paid by you/advanced by you. Manually enter the tracking number.">Shipping fees must be paid by you/advanced by you. Manually enter the tracking number.</div>
                  <span style={{ position: 'absolute', right: 18, top: 18 }}>
                    <RadioIcon checked={returnType === 'self'} />
                  </span>
                </div>
                {/* 仅选中时显示内容和按钮 */}
                {returnType === 'self' && (
                  <>
                    {/* 分组卡片外框 */}
                    <div className={styles3['self-return-card']}>
                      <div className={styles3['self-return-inputs']}>
                        <input
                          className={styles3['self-return-input']}
                          placeholder="Please enter the tracking number"
                          value={trackingNumber}
                          onChange={e => setTrackingNumber(e.target.value)}
                        />
                        <input
                          className={styles3['self-return-input']}
                          placeholder="name"
                          value={name}
                          onChange={e => setName(e.target.value)}
                        />
                        <input
                          className={styles3['self-return-input']}
                          placeholder="Contact information"
                          value={contactInfo}
                          onChange={e => setContactInfo(e.target.value)}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            {/* 唯一Confirm按钮 */}
            {returnType && (
              <div className={styles3['buyer-return-confirm']}>
                <Button
                  type="primary"
                  style={{ width: 320, height: 44, fontSize: 18, background: '#21b47b', borderColor: '#21b47b', fontWeight: 700 ,boxShadow:'none'}}
                  onClick={() => {
                    if (returnType === 'pickup' && pickupTime) {
                      setVerificationCode(generateVerificationCode());
                      setShowVerificationModal(true);
                    }
                  }}
                  disabled={returnType === 'pickup' && !pickupTime}
                >
                  Confirm
                </Button>
              </div>
            )}
            
            <div className={styles3['return-actions']}>
              <Button onClick={onBack} className={styles3['back-button']}>
                Back
              </Button>
              <Button type="primary" onClick={onNext} className={styles3['next-button']}>
                Confirm Return
              </Button>
            </div>
          </div>
          <div className={styles['history-title']}>Negotiation History</div>

          <div className={styles3['negotiation-history']}>
            <img
              src={require('../../../../assets/images/组 2233@2x.png')}
              alt="avatar"
              className={styles3['negotiation-avatar']}
            />
            <div className={styles3['negotiation-info']}>
              <div className={styles3['negotiation-header']}>
                <span className={styles3['negotiation-name']}>RefundStep3</span>
                <span className={styles3['negotiation-time']}>2025-07-01 10:20:20</span>
              </div>
              <div className={styles3['negotiation-action']}>The Seller Has Approved Your Return Request</div>
            </div>
          </div>
          <div className={styles3['negotiation-divider']}></div>
          <div className={styles['history-list']}>
            {negotiationHistory.map((item: any, idx: number) => (
              <div className={styles['history-item']} key={idx}>
                <img className={styles['avatar']} src={item.userAvatar} alt="avatar" />
                <div className={styles['history-info']}>
                  <div className={styles['history-header']}>
                    <span className={styles['user-name']}>{item.userName}</span>
                    <span className={styles['history-time']}>{item.time}</span>
                  </div>
                  <div className={styles['history-action']}>{item.action}</div>
                  <div className={styles['history-detail']}>
                    <div><span>Refund Type:  </span>  {item.refundType}  </div>
                    <div><span>Refund Amount: </span>  {item.refundAmount}</div>
                    <div><span>Refund Reason: </span>  {item.refundReason}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* 右侧详情区 */}
        <div className={styles['side-panel']}>
          <div className={styles['side-title']}>Return Details</div>
          <div className={styles['side-product']}>
            <img className={styles['side-img']} src={productImg} alt="product" />
            <div className={styles['side-info']}>
              <div className={styles['side-title-main']}>{productTitle}</div>
              <div className={styles['side-class']}>{productClass}</div>
            </div>
          </div>
          <div className={styles['side-list']}>
            <div><span>Seller:</span> {sellerName}</div>
            <div><span>Order Number:</span> {orderNumber}</div>
            <div><span>Unit Price:</span> ${unitPrice}</div>
            <div><span>Shipping Fee:</span> ${shippingFee}</div>
            <div><span>Total Price:</span> ${totalPrice}</div>
            <div>
              <span>Total Refund Amount:</span>
              <span>{refundAmount}</span>
            </div>
            <div className={styles['side-list-box']}></div>
            <div><span>Refund Number:</span> {refundNumber}</div>
            <div><span>Refund Amount:</span> {refundAmount}</div>
            <div><span>Refund Reason:</span> {refundReason}</div>
            <div><span>Request:</span> {refundType}</div>
            <div><span>Goods status:</span> {goodsStatus}</div>
          </div>
        </div>
      </div>
      <FAQSection />
      {showVerificationModal && (
        <div className={styles3['verification-modal-overlay']}>
          <div className={styles3['verification-modal-content']}>
            <span
              className={styles3['verification-modal-close']}
              onClick={() => setShowVerificationModal(false)}
            >×</span>
            <div className={styles3['verification-modal-title']}>Verification Code</div>
            <div className={styles3['verification-modal-desc']}>Please Inform The Doorstep Courier Of This Verification Code</div>
            <div className={styles3['verification-modal-code']}>{verificationCode}</div>
            <Button
              type="primary"
              className={styles3['verification-modal-btn']}
              onClick={() => setShowVerificationModal(false)}
            >
              Confirm
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default BuyerReturnStep; 